import Constants from 'expo-constants';

/**
 * The privacy/support contact published in the app's legal screens and used by
 * Contact Support.
 *
 * This has a hard fallback on purpose. The address previously came only from
 * EXPO_PUBLIC_SUPPORT_EMAIL, which was not set in any committed environment, so the
 * published privacy policy shipped with no contact at all and in-app support was a
 * dead end. An environment override is still honoured; an omission can no longer
 * blank the contact.
 */
export const DEFAULT_SUPPORT_EMAIL = 'decimaldrown@gmail.com';

export const SUPPORT_EMAIL: string = (
  process.env.EXPO_PUBLIC_SUPPORT_EMAIL ||
  Constants.expoConfig?.extra?.EXPO_PUBLIC_SUPPORT_EMAIL ||
  DEFAULT_SUPPORT_EMAIL
).trim();
